<template>
  <app-dlg
      title="Import Employees"
      :show-dlg.sync="shownRelay"
      :default-padding="false"
      :show-loading="importingEmployees"
      :loading-progress="importingEmployees ? Math.round((importedSuccessCount + importedErrorCount) / importList.length * 100) : 0"
      :dlg-width="stage >= 1 ? 800 : 400"
  >
    <template v-slot:default>
      <v-scroll-x-transition hide-on-leave>
        <v-form
            v-if="stage === 0"
            ref="employeeListForm"
            autocomplete="new-password"
            @submit="$event.preventDefault()"
        >
          <div class="pb-0 px-6">
            <v-textarea
                outlined
                ref="employeeInput"
                label="Paste list of employees here"
                :rows="4"
                v-model="employeesInputStr"
                :rules="[validationRules.required]"
            ></v-textarea>
            
            <!--            <div class="d-flex align-start">-->
            <!--              <v-autocomplete-->
            <!--                class="flex-grow-1"-->
            <!--                dense-->
            <!--                outlined-->
            <!--                color="primary"-->
            <!--                v-model="selectedTeamId"-->
            <!--                label="Team"-->
            <!--                placeholder="eg. Finance"-->
            <!--                :items="sortedTeams"-->
            <!--                item-text="name"-->
            <!--                item-value="_id"-->
            <!--                :rules="[validationRules.required]"-->
            <!--                hide-details="auto"-->
            <!--              />-->
            <!--              <v-tooltip top>-->
            <!--                <template v-slot:activator="{on}">-->
            <!--                  <v-btn-->
            <!--                    class="ml-2"-->
            <!--                    icon-->
            <!--                    color="primary"-->
            <!--                    v-on="on"-->
            <!--                    @click="showCreateTeam = true"-->
            <!--                  >-->
            <!--                    <v-icon>mdi-plus</v-icon>-->
            <!--                  </v-btn>-->
            <!--                </template>-->
            <!--                Create new Team-->
            <!--              </v-tooltip>-->
            <!--            </div>-->
            
            <!--Create New Team-->
            <!--            <app-team-add v-if="showCreateTeam" :shown.sync="showCreateTeam" :show-employees="false" @input="selectedTeamId = $event._id"/>-->
          
          </div>
        </v-form>
      </v-scroll-x-transition>
      <div class="pb-4">
        <v-scroll-x-transition hide-on-leave>
          <div v-if="stage >= 1">
            <!--            <v-data-table-->
            <!--              ref="table"-->
            <!--              :headers="headers"-->
            <!--              :items="importList"-->
            <!--              :items-per-page="importList.length"-->
            <!--              hide-default-footer-->
            <!--              fixed-header-->
            <!--              class="fill-height of-y full-table"-->
            <!--              item-key="_id"-->
            <!--            ></v-data-table>-->
            
            
            <div style="overflow-y: auto; height: 500px">
              <v-data-table
                  ref="table"
                  :headers="headers"
                  :items="importList"
                  :items-per-page="importList.length"
                  hide-default-footer
                  fixed-header
                  class="fill-height of-y full-table text-h6"
                  item-key="device"
                  selectable-key="device"
                  
              >
                
                <template #item.name="{ item: {name, refEmployee: ref} }">
                  <div style="line-height: 1 !important;" class="d-flex fill-height justify-center flex-column">
                  <span style="line-height: 1" class="body-2 font-weight-medium"
                        :class="{'error--text': !name, 'font-weight-black': !name}">
                    {{ name || 'Employee is required' }}
                  </span>
                    <span v-if="!!name" style="line-height: 1" class="caption pt-1" :class="{
                    'warning--text': !!ref,
                    'success--text': !ref,
                  }">
                    {{!ref ? 'Create employee' : `Link to existing employee: ${ref.name}` }}
                  </span>
                  </div>
                </template>
                
                <template #item.team="{ item: {team: name, refTeam: ref} }">
                  <div style="line-height: 1 !important;" class="d-flex fill-height justify-center flex-column">
                  <span style="line-height: 1" class="body-2 font-weight-medium"
                        :class="{'error--text': !name, 'font-weight-black': !name}">
                    {{ name || 'NO TEAM SPECIFIED' }}
                  </span>
                    <span v-if="name" style="line-height: 1" class="caption pt-1" :class="{
                    'warning--text': !!ref,
                    'success--text': !ref,
                  }">
                    {{ !ref ? 'Create team' : `Link to existing team: ${ref.name}` }}
                  </span>
                  </div>
                </template>
                
                <template #item.device="{ item: {device: name, refDevice: ref} }">
                  <div style="line-height: 1 !important;" class="d-flex fill-height justify-center flex-column">
                  <span style="line-height: 1" class="body-2 font-weight-medium"
                        :class="{'grey--text': !name, 'error--text': name && !ref}">
                    {{ name || '-' }}
                  </span>
                    <span v-if="name" style="line-height: 1" class="caption pt-1" :class="{
                    'success--text': !!ref,
                    'error--text': !ref,
                  }">
                    {{ !ref ? 'Device not found' : `Link existing device: ${ref.name}` }}
                  </span>
                  </div>
                </template>
                
                <template #item.employeeNumber="{ item }">
                  <div style="line-height: 1 !important;" class="d-flex fill-height justify-center flex-column">
                    <span style="line-height: 1" class="body-2 font-weight-medium" :class="{'grey--text': !item.employeeNumber}">
                      {{ item.employeeNumber || '-' }}
                    </span>
                  </div>
                </template>

                <template #item.actions="{ item, index }">
                  <v-tooltip left v-if="stage !== 2">
                    <template #activator="{on}">
                      <v-btn v-on="on" icon text color="error" @click="importList.splice(index, 1)">
                        <v-icon>$delete</v-icon>
                      </v-btn>
                    </template>
                    Remove Employee
                  </v-tooltip>
                  <div v-else-if="item.status === 'busy'" style="overflow: hidden !important;" class="d-flex align-center justify-center fill-height">
                    <v-progress-circular style="overflow: hidden !important;" :indeterminate="true" class="pa-2" :size="28" :width="2" color="secondary"></v-progress-circular>
                  </div>
                  <div v-else-if="item.status === 'done'" style="overflow: hidden !important;" class="d-flex align-center justify-center fill-height">
                      <v-btn icon text color="success">
                      <v-icon>$success</v-icon>
                    </v-btn>
                  </div>
                  <div v-else-if="item.status === 'error'" style="overflow: hidden !important;" class="d-flex align-center justify-center fill-height">
                    <v-btn icon text color="error">
                      <v-icon>$error</v-icon>
                    </v-btn>
                  </div>
                </template>
                
                <!--                <template #item.device="{item}">-->
                <!--                  <div-->
                <!--                    class="d-flex align-center"-->
                <!--                    :class="!item.deviceFound ? 'error&#45;&#45;text' : null"-->
                <!--                  >-->
                <!--                    {{ item.device }}-->
                <!--                    <template v-if="!item.deviceFound">&nbsp;-&nbsp;<span class="caption font-italic">Device not Found</span></template>-->
                <!--                  </div>-->
                <!--                </template>-->
                
                <!--                <template #item.name="{name}">-->
                <!--                  <div-->
                <!--                      class="d-flex align-center"-->
                <!--                      :class="!item.deviceFound ? 'error&#45;&#45;text' : null"-->
                <!--                  >-->
                <!--                    {{ item.name }}-->
                <!--                    <template v-if="!item.deviceFound">&nbsp;-&nbsp;<span class="caption font-italic">Device not Found</span></template>-->
                <!--                  </div>-->
                <!--                </template>-->
              </v-data-table>
            </div>
            
            <!--            <template v-if="!importList.length">-->
            <!--              <div class="overline error&#45;&#45;text text-center px-6">-->
            <!--                No Employees To Import-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <div v-else>-->
            <!--              <div class="body-1 px-6">-->
            <!--                Employees To Import-->
            <!--              </div>-->
            <!--              <v-list-->
            <!--                style="max-height: 300px"-->
            <!--                dense-->
            <!--                class="of-y"-->
            <!--              >-->
            <!--                <template v-for="(emp, index) in importList">-->
            <!--                  <v-list-item @click="() => {}" :key="emp">-->
            <!--                    <v-list-item-avatar>-->
            <!--                      <v-icon>mdi-account-multiple</v-icon>-->
            <!--                    </v-list-item-avatar>-->
            <!--                    <v-list-item-content>-->
            <!--                      <v-list-item-title v-text="emp"></v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                    <v-list-item-action>-->
            <!--                      <v-btn-->
            <!--                        small-->
            <!--                        icon-->
            <!--                        color="error"-->
            <!--                        class="pa-0 ma-0"-->
            <!--                        @click="importList.splice(index, 1)"-->
            <!--                      >-->
            <!--                        <v-icon>mdi-delete</v-icon>-->
            <!--                      </v-btn>-->
            <!--                    </v-list-item-action>-->
            <!--                  </v-list-item>-->
            <!--                </template>-->
            <!--              </v-list>-->
            <!--            </div>-->
          </div>
        </v-scroll-x-transition>
      </div>
      
<!--      <v-scroll-x-transition hide-on-leave>-->
<!--        <div v-if="stage === 2" class="pb-4 px-6">-->
<!--          <div class="overline blue&#45;&#45;text">-->
<!--            {{ importingEmployees ? `Importing: ${importedErrorCount.employees + importedErrorCount.teams + importedSuccessCount.teams + importedSuccessCount.employees + 1} of ${importList.length}` : 'Import Complete' }}-->
<!--          </div>-->
<!--          <div class="error&#45;&#45;text overline">-->
<!--            <div>Import Errors:</div>-->
<!--            <div>Employees: {{ importedErrorCount.employees }}</div>-->
<!--            <div>Teams: {{ importedErrorCount.teams }}</div>-->
<!--          </div>-->
<!--          <div class="success&#45;&#45;text overline">-->
<!--            <div>Import Success:</div>-->
<!--            <div>Employees: {{ importedSuccessCount.employees }}</div>-->
<!--            <div>Teams: {{ importedSuccessCount.teams }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </v-scroll-x-transition>-->
    </template>
    
    <template v-slot:actions>
      
      <div class="text-overline" v-if="importStatusText">
        {{ importStatusText }}
      </div>
      
      <div class="text-overline error--text" v-if="stage === 1 && importList.length && importReady !== true">
        {{ importReady }}
      </div>
      
      <v-btn
          class="ml-2"
          small
          color="primary"
          @click="shownRelay = false"
          outlined
          size="small"
          :disabled="importingEmployees"
          v-if="!importDone"
      >Cancel
      </v-btn>
      
      <v-scroll-x-transition hide-on-leave>
        <v-btn
            v-if="stage === 2 && importDone"
            small
            class="ml-2"
            size="small"
            color="secondary"
            variant="contained"
            @click="shownRelay = false"
        >Done
        </v-btn>
      </v-scroll-x-transition>
      
      <v-scroll-x-transition hide-on-leave>
        <v-btn
            v-if="stage === 0"
            small
            outlined
            size="small"
            class="ml-2"
            color="secondary"
            variant="contained"
            @click="validateInput"
        >Next
        </v-btn>
      </v-scroll-x-transition>
      
      <v-scroll-x-transition hide-on-leave>
        <v-btn
            v-if="(stage === 1 && importList.length) || (!importDone && stage === 2)"
            small
            class="ml-2"
            size="small"
            color="secondary"
            variant="contained"
            :disabled="importingEmployees || importReady !== true"
            :loading="importingEmployees"
            @click="importEmployees"
        >Start Import
        </v-btn>
      </v-scroll-x-transition>
    
    </template>
  </app-dlg>
</template>

<script>
import AppDlg from "@/components/Shared/AppDlg";
import {nameSort, validationRules} from "@/core/codeFunctions";
import {mapGetters} from "vuex";
import {Employee} from "@/models/employee";
import AppTeamAdd from "@/components/Teams/AppTeamAdd";
import {Team} from "@/models/team";
import {Device} from "@/models/device";

export default {
  components: {AppTeamAdd, AppDlg},
  props: {
    shown: Boolean,
  },
  data() {
    return {
      stage: 0,
      employeesInputStr: null,
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Team', value: 'team'},
        {text: 'Device', value: 'device'},
        {text: 'Employee Number', value: 'employeeNumber'},
        {text: null, value: 'actions', width: '50px'},
      ],
      importList: null,
      validationRules,
      importedSuccessCount: {
        employees: 0,
        teams: 0,
      },
      importedErrorCount: {
        employees: 0,
        teams: 0,
      },
      importingEmployees: false,
      importDone: false,
      selectedTeamId: null,
      showCreateTeam: false,
      importStatusText: null
    }
  },
  watch: {
    shown: {
      immediate: true,
      handler(val) {
        if (val)
          setTimeout(() => {
            this.$refs.employeeInput.focus()
          }, 500)
      }
    }
  },
  methods: {
    validateInput() {
      if (!this.$refs.employeeListForm.validate())
        return;
      // const existingEmployees = this.employees.map(emp => (emp.name || '').trim().toLowerCase());
      this.importList = this.employeesInputStr
          // .replace(/\t|\r/gi, '')
          .split(/\n/)
          .map(row => row.split('\t'))
          .filter(row => row.length > 1)
          .map(([name, team, device, employeeNumber]) => [(name || '').trim(), (team || '').trim(), (device || '').trim(), (employeeNumber || '').trim()])
          .map(([name, team, device, employeeNumber]) => {
            return {
              name: name || null,
              team: team || null,
              device: device || null,
              employeeNumber: employeeNumber || null,
              refDevice: this.$store.getters.devices.find(obj => (obj.name || '').toLowerCase().trim().includes((device || '').toLowerCase())),
              refEmployee: this.$store.getters.employees.find(obj => (obj.name || '').toLowerCase().trim() === (name || '').toLowerCase()),
              refTeam: this.$store.getters.teams.find(obj => (obj.name || '').toLowerCase().trim() === (team || '').toLowerCase()),
              status: null
            }
          })
      
      this.importList.sort(nameSort);
      this.stage = 1;
      
    },
    
    ntProm() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true)
        }, 300)
      })
    },
    
    async importEmployees() {
      const vm = this;
      this.importStatusText = null;
      this.importingEmployees = true;
      this.stage = 2
      
      async function createTeam(teamName) {
        const team = new Team({name: teamName});
        const refTeam = await team.create([]);
        for (const item of vm.importList) {
          if (item.team.toLowerCase().trim() === refTeam.name.toLowerCase().trim())
            item.refTeam = refTeam
        }
      }
      async function runEmployee(item) {
        item.status = 'busy'
        try {
          const team = item.refTeam;
          let employee;
          if (item.refEmployee) {
            employee = new Employee(JSON.parse(JSON.stringify(item.refEmployee)))
          } else {
            // New Employee
            const newEmployee = new Employee({name: item.name, teamId: team._id});
            employee = await newEmployee.create([]);
          }
          
          // Switch Team
          if (employee.teamId !== team._id) {
            employee.teamId = team._id
            await employee.update('teamId');
          }

          // Update Employee Number
          if (item.employeeNumber && employee.employeeNumber !== item.employeeNumber) {
            employee.employeeNumber = item.employeeNumber
            await employee.update('employeeNumber');
          }
          
          // Link Device
          if (item.refDevice) {
            const device = new Device(JSON.parse(JSON.stringify(item.refDevice)));
            if (device.employeeId !== employee._id) {
              device.employeeId = employee._id
              await device.update('employeeId')
            }
          }
          item.status = 'done'
        } catch (e) {
          console.log(e);
          item.status = 'error'
        }
      }
      
      try {
        vm.importingEmployees = true
        // 1. Create All Teams
        vm.importStatusText = 'Creating Teams'
        const teamsToCreate = vm.importList
            .filter(v => v.team && !v.refTeam)
            .map(v => v.team)
            .filter((v,i,a) => a.indexOf(v) === i)
        
        await Promise.all(teamsToCreate.map(createTeam))
        vm.importStatusText = 'Processing employees'
        
        for (const value of this.importList) {
          value.status = 'busy'
        }
        
        await this.ntProm()
        
        // 2. Employees Run
        const results = await Promise.allSettled(vm.importList.map(runEmployee))
        
        const successCount = results.filter(v => v.status === 'fulfilled').length
        const failCount = results.filter(v => v.status === 'rejected').length
        
        const resultArr = []
        if (successCount)
          resultArr.push(`${successCount} employee${successCount !== 1 ? 's' : ''} imported successfully`)
        if (failCount)
          resultArr.push(`${failCount} employee${failCount !== 1 ? 's' : ''} failed to import`)
        
        vm.importStatusText = resultArr.join(' | ')
        vm.importDone = true;
      } catch (e) {
        console.log(e)
        vm.$snack.netWorkError()
      } finally {
        vm.importingEmployees = false
      }
    }
  },
  computed: {
    ...mapGetters(['employees', 'teamsWithAccess', "teams", "employees", "devices"]),
    sortedTeams() {
      return [...this.teamsWithAccess].sort(nameSort)
    },
    shownRelay: {
      get() {
        return this.shown
      },
      set(val) {
        this.$emit('update:shown', val)
      }
    },
    importReady() {
      // 1. Emp with no name
      if (this.importList.find(v => !v.name))
        return 'Employee name error'
      // 2. No Team
      if (this.importList.find(v => !v.team))
        return 'Employee team not specified'
      // 3. Device not found
      if (this.importList.find(v => v.device && !v.refDevice))
        return 'Device not found'
      // Ready to import
      return true
    }
  }
}
</script>

<style scoped>

</style>